import { render, staticRenderFns } from "./ExamInfo.vue?vue&type=template&id=70e12d7f&scoped=true&"
import script from "./ExamInfo.vue?vue&type=script&lang=js&"
export * from "./ExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./ExamInfo.vue?vue&type=style&index=0&id=70e12d7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e12d7f",
  null
  
)

export default component.exports